// This is a generated file. Manual changes will be overwritten.

import React from "react";
import PropTypes from "prop-types";

export function IconWebcast({ className, size, color }) {
  const s = size || "1em";

  const attr = { version: "1.1", viewBox: "0 0 32 32" };

  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      {...attr}
      className={className}
      style={{ color }}
      height={s}
      width={s}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M25.898 12.718l3.395 2.008v-5.704h-9.653l3.398 2.010-5.248 3.099v3.378l8.107-4.79z" />
      <path d="M17.25 13.477v-11.854c-0.131 0-0.262-0.022-0.395-0.022-7.755 0-14.064 6.459-14.064 14.4 0.003 1.734 0.308 3.396 0.866 4.937l-0.032-0.102c-0.561 0.48-0.914 1.187-0.917 1.977v0c-0 0.010-0 0.021-0 0.032 0 1.403 1.129 2.543 2.528 2.56h0.002c0.305-0.002 0.597-0.060 0.864-0.166l-0.016 0.006c2.563 3.145 6.432 5.141 10.767 5.155h0.002c0.133 0 0.264-0.016 0.395-0.019v-12.042c0.994-0.379 1.687-1.324 1.687-2.431s-0.693-2.052-1.669-2.425l-0.018-0.006zM16.416 3.448v5.365h-2.987c-0.144-0.756-0.602-1.384-1.23-1.753l-0.012-0.007c0.302-0.568 0.621-1.056 0.977-1.512l-0.017 0.023c0.941-1.213 2.061-1.965 3.269-2.115zM10.594 11.858c0.104 0.019 0.225 0.031 0.35 0.035l0.004 0c1.266-0.014 2.309-0.949 2.491-2.165l0.002-0.014h2.976v3.605c-1.284 0.014-2.338 0.977-2.495 2.219l-0.001 0.013h-3.68c0.021-1.319 0.148-2.594 0.375-3.835l-0.021 0.142zM9.954 9.298c0.013-0.537 0.452-0.968 0.992-0.968 0.548 0 0.992 0.444 0.992 0.992s-0.443 0.991-0.99 0.992h-0c-0.55-0.006-0.994-0.454-0.994-1.005 0-0.002 0-0.003 0-0.005v0zM13.6 3.854c-0.892 0.811-1.631 1.773-2.179 2.848l-0.026 0.056c-0.125-0.029-0.268-0.045-0.414-0.045-0.029 0-0.057 0.001-0.086 0.002l0.004-0c-1.218 0.035-2.22 0.921-2.434 2.082l-0.002 0.016h-1.712c1.618-2.373 3.988-4.13 6.763-4.937l0.087-0.022zM6.197 9.714h2.258c0.128 0.808 0.616 1.482 1.293 1.859l0.013 0.007c-0.237 1.182-0.384 2.551-0.408 3.951l-0 0.020h-4.784c0.069-2.155 0.665-4.156 1.662-5.899l-0.033 0.062zM5.258 23.83c-0.007 0-0.016 0-0.024 0-0.562 0-1.018-0.456-1.018-1.018s0.456-1.018 1.018-1.018c0.561 0 1.017 0.455 1.018 1.016v0c0 0.003 0 0.007 0 0.011 0 0.552-0.443 1-0.993 1.008h-0.001zM5.267 20.222c-0.401-1.118-0.653-2.408-0.699-3.752l-0.001-0.021h4.787c0.029 2.119 0.349 4.153 0.922 6.078l-0.040-0.158h-2.51c-0.198-1.205-1.218-2.117-2.456-2.147l-0.003-0zM7.426 24.096c0.139-0.241 0.244-0.521 0.298-0.819l0.002-0.016h2.813c0.64 1.795 1.656 3.658 3.093 4.891-2.512-0.715-4.63-2.137-6.189-4.035l-0.017-0.021zM16.416 28.534c-2.45-0.306-4.086-2.915-4.96-5.28h4.96zM16.416 22.365h-5.28c-0.551-1.766-0.881-3.799-0.909-5.905l-0-0.015h3.704c0.24 1.169 1.254 2.037 2.474 2.050h0.011zM16.406 16.925c-0.008 0-0.017 0-0.026 0-0.562 0-1.018-0.456-1.018-1.018s0.456-1.018 1.018-1.018c0.561 0 1.017 0.454 1.018 1.016v0c0 0.004 0 0.009 0 0.014 0 0.551-0.442 0.998-0.991 1.006h-0.001z" />
    </svg>
  );
}

IconWebcast.propTypes = {
  /**
   * Size in pixels (or a string with the size in CSS units)
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * A CSS color string.
   */
  color: PropTypes.string,
};
